import React from 'react'
import { Grid } from 'semantic-ui-react'
import InputField from '../../../commonComponents/formComponents/inputField'
import DropDown from '../../../commonComponents/formComponents/dropDown'
import { useDispatch, useSelector } from 'react-redux'
import DeleteIcon from '../../../commonComponents/deleteIcon'
import CopyRepElement from './copyRepElement'
import PopUpIcon from '../../../commonComponents/formComponents/PopUpIcon'
import { useCurrentShipmentType } from '../../../hooks/useCurrentShipmentType'


const TaxInformationDetails = ({ isFormDisabled, saveItem, deleteItem, updateItem, copyData, merchandiseId, item: { id, taxType, taxBase, taxRate, taxAmount, totalTaxes, mop, cdsNotificationTax = "false" } }) => {
  const taxTypeList = useSelector((state) => state.DropDownValues.taxType)
  const unitAndQualifier = useSelector((state) => state.DropDownValues.unitAndQualifier)
  const mopList = useSelector((state) => state.DropDownValues.mop)
  const { isDisabled } = useCurrentShipmentType()
  const dispatch = useDispatch()
  return (

    <Grid.Row >

      <Grid.Column width={1} style={{ textAlign: 'center' }}>
        <span>
          <CopyRepElement
            title={`TAX INFORMATION`}
            request={{ taxType, taxBase, taxRate, taxAmount, totalTaxes, mop, cdsNotificationTax }}
            callback={copyData}
            isFormDisabled={isDisabled}
          />
          {cdsNotificationTax === "true" && <PopUpIcon icon='info circle' popupText={"CDS DUTY"} />}</span>

      </Grid.Column>

      <Grid.Column width={2} className='divFormFeild border-bottom b-rw-0'>

        <DropDown
          id={`taxType-${id}`}
          label="Tax type"
          disabled={isFormDisabled}
          className='field-bg dropdown100 addInfoCode'
          boxNumber='4/3'
          labelClass='text-none'
          isLabel={true}
          mandatory={false}
          direction='right'
          data={taxTypeList}
          value={taxType}
          clearable
          onChange={(value) => {
            updateItem(id, { taxType: value?.trim() })
            saveItem({ id, taxType: value })
          }}

        />

      </Grid.Column>
      <Grid.Column width={3} className='divFormFeild border-bottom b-rw-0'>

        <DropDown
          id={`qualifier-${id}`}
          className='field-bg dropdown100 addInfoCode'
          labelClass='text-none'
          isLabel={false}
          disabled={isFormDisabled}
          label="Unit and Qualifier"
          boxNumber="4/4"
          data={unitAndQualifier}
          value={taxBase}
          clearable
          onChange={(value) => {
            updateItem(id, { taxBase: value?.trim() })
            saveItem({ id, taxBase: value })
          }}
        />
      </Grid.Column>
      <Grid.Column width={3} className='divFormFeild border-bottom b-rw-0'>

        <InputField
          id={`quantity-${id}`}
          className='field-bg'
          disabled={isFormDisabled}
          type="number"
          label="Quantity"
          boxNumber="4/4"
          value={taxRate}
          onChange={(value) => updateItem(id, { taxRate: value })}
          onBlur={() => saveItem({ id, taxRate: taxRate || " " })}
        />
      </Grid.Column>

      <Grid.Column width={2} className='divFormFeild border-bottom  b-rw-0'>
        <InputField
          isLabel={false}
          disabled={isFormDisabled}
          id={`taxAmount-${id}`}
          type='number'
          label='Payable Tax Amount'
          boxNumber="4/6"
          value={taxAmount}
          className='field-bg'
          onChange={(value) => updateItem(id, { taxAmount: value })}
          onBlur={() => saveItem({ id, taxAmount: taxAmount || " " })}
        />
      </Grid.Column>
      <Grid.Column
        width={2}
        className="divFormFeild border-bottom b-rw-0"
      >
        <InputField
          isLabel={false}
          id={`totalTaxes${id}`}
          disabled={isFormDisabled}
          type="number"
          label="Total Taxes"
          boxNumber="4/7"
          value={totalTaxes}
          className="field-bg"
          clearInput={false}
          onChange={(value) => updateItem(id, { totalTaxes: value })}
          onBlur={() => saveItem({ id, totalTaxes: totalTaxes || " " })}

        />
      </Grid.Column>
      <Grid.Column width={2} className='divFormFeild border-bottom'>
        <DropDown
          id={`mop-${id}`}
          label="MOP"
          boxNumber="4/8"
          disabled={isFormDisabled}
          className='field-bg dropdown100 addInfoCode'
          labelClass='text-none'
          isLabel={true}
          data={mopList}
          clearable
          value={mop}
          onChange={async (value) => {
            updateItem(id, { mop: value?.trim() })
            if (value === 'E') {
              const res = await saveItem({ id, mop: value })
              if (!!res?.form?.invoice?.merchandise?.[merchandiseId]?.authorisation?.length)
                dispatch({
                  type: 'ADD_MULTI_DOC_BY_MERCHANDISE_ID',
                  ids: [{merchandiseId}],      
                  payload: res?.form?.invoice?.merchandise?.[merchandiseId]?.authorisation||[],
                  meta: { tableName: 'authorisation' }
                })
              return
            }
           else if(value !== 'E'){
              const res = await saveItem({ id, mop: value })
              if (!!res?.form?.invoice?.merchandise?.[merchandiseId]?.authorisation?.length){
                const idsToDelete = res?.form?.invoice?.merchandise?.[merchandiseId]?.authorisation.map((item) => item.id) || []
                dispatch({
                  type: 'DELETE_MULTI_DOC_BY_MERCHANDISE_ID',
                  ids: [{merchandiseId}],      
                  payload: idsToDelete,
                  meta: { tableName: 'authorisation' }
                })
              return
            }}
            saveItem({ id, mop: value })
          }}
        />
      </Grid.Column>

      <Grid.Column width="1" className="icon-delete-add-info">
        <DeleteIcon onClick={() => deleteItem(id)} disabled={isFormDisabled} />

      </Grid.Column>
    </Grid.Row>


  )
}


export default TaxInformationDetails